








































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import { AloPanier } from '@/models/alo/AloPanier';
import { ItemPanier } from '@/models/alo/ItemPanier';

@Component({
  name: 'CartSupItem',
  props: {
    item:{
      type:Object,
      required:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }
  }
})
export default class CartSupItem extends Vue {
  item!:ItemPanier   
  value!:string
  readOnly!:Boolean

  get hasOption() {
    return (this.item.prixSupplementsAccompagnement + this.item.prixSupplementsCarte) > 0
  }

  get accompagnements(){
    let nbGratuitRestant = this.item.plat.qtyAccompagnementGratuit??0
    return this.item?.accompagnements.filter(i =>i.qty > 0).map(it => {      
      const item = {...it,prix: Math.max(0,it.qty - nbGratuitRestant) * this.item.plat.prixAccompagnement! }             
      nbGratuitRestant = Math.max(0,nbGratuitRestant-it.qty)
      return item
    })    
  }

  get qtyAccompagnements(){
    return this.accompagnements.reduce((total,a)=>{
      return total+a.qty
    },0)
  }

  get platsDic(){    
    return this.$store.myGetters.platsDic
  }

  get defaultItems() {
    return this.plats.filter(p => p && p.template == "plat-produit-menu-breakfast-default-item")
  }

  get plats() {
    return (this.item.plat.platsIds?.map(id => this.platsDic[id]) || []).filter(it => it)
  }


}
